import React, { useState } from 'react';
import { SecondaryButton } from "../UI";
import { useUserContext } from '../../contexts/UserContext';
import CreateBulkOfferModal from './CreateBulkOfferModal';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const Activation = ({
    experiences,
    validationError,
    offerPermission,
}) => {
    const [showCreateOfferModal, setShowCreateOfferModal] = useState(false);

    const { userData, checkPermission } = useUserContext();
    const { content } = useContentfulContext();
    const selectedOrgLevel = userData?.selectedOrganization?.level;

    const closeCreateOfferModal = () => { 
        setShowCreateOfferModal(false);
    };

    return (
        <div>
            <div className="my-4 px-8 w-full">
                {validationError && (
                    <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded" role="alert">
                        <p>{validationError}</p>
                    </div>
                )}

                {selectedOrgLevel?.route_permission['adobe-io-integrations'] == true && (
                    <section className="bg-white shadow-lg rounded-lg overflow-hidden">
                        <div className="bg-slate-100 px-6 py-4">
                            <h2 className="text-2xl font-bold text-gray-800">{content.BULK_ACTIVATION_CONTENT.adobe_target.title}</h2>
                        </div>
                        <div className="p-6 space-y-6">
                            <div className="flex flex-wrap justify-start items-center gap-4">
                                {checkPermission(offerPermission.create) && (
                                    <SecondaryButton
                                        handleClick={() => {
                                            setShowCreateOfferModal(true)
                                        }}
                                    >
                                        {content.BULK_ACTIVATION_CONTENT.adobe_target.create_offers_cta}
                                    </SecondaryButton>
                                )}
                            </div>
                        </div>
                    </section>
                )}

                {selectedOrgLevel?.route_permission['adobe-io-integrations'] == false &&
                    <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded w-full" role="alert">
                        <p>{content.BULK_ACTIVATION_CONTENT.no_activation_found}</p>
                    </div>
                }
            </div>

            {showCreateOfferModal && (
                <CreateBulkOfferModal
                    experiences={experiences}
                    hideCreateOfferModal={closeCreateOfferModal}
                />
            )}

        </div>
    );
};

export default Activation;